import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deliverydetail',
  templateUrl: './deliverydetail.component.html',
  styleUrls: ['./deliverydetail.component.css']
})
export class DeliverydetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
